<template>
	<div class="notifications__rapper">
		<router-link v-if="bellLoaded" class="notifications" :to="{ name: 'MessageCenter' }">
			<div class="notification-bell" :class="{ 'bell-ringing': notificationCount > 0 }"></div>
			<div class="notification-count-container" v-if="notificationCount > 0">
				<div class="notification-count">
					{{ notificationCount > 99 ? '99+' : notificationCount }}
				</div>
			</div>
		</router-link>
	</div>
</template>

<script lang="ts" setup>
// ====---------------====
// 🚀 Imports
// ====---------------====
import { computed, onMounted, ref } from 'vue'
import { useMessageCountStore } from '../stores/messageCenter/messageCount'

// ====---------------====
// 💡 Data
// ====---------------====
const bellLoaded = ref(false)
const notificationCount = computed(() => {
	return useMessageCountStore().getTotal()
})

// ====---------------====
// 🌄 Lifecycle
// ====---------------====
onMounted(async () => {
	// initialize count store
	await useMessageCountStore()
		.getStore()
		.then(() => {
			bellLoaded.value = true
		})
	useMessageCountStore().getTotal()
})
</script>

<style lang="scss" scoped>
.notifications {
	position: relative;
	margin-right: 30px;
	display: flex;
	align-items: center;
	width: 33px;
	cursor: pointer;
}

.notification-bell {
	background-image: url('@/assets/notification-bell.svg');
	background-position: 0 0;
	background-repeat: no-repeat;
	background-size: contain;
	height: 26px;
	width: 26px;
}

.notification-bell.bell-ringing {
	background-image: url('@/assets/notification-bell-ringing.svg');
}

.notification-count-container {
	position: absolute;
	top: -1px;
	left: 0;
	margin-left: 12px;
	border-radius: 12px;
	background: $primary-600;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 2px 7px;
}

.notification-count {
	color: #fff;
	font-size: 11px;
}

@media only screen and (max-width: 1305px) {
	.notifications {
		margin-right: 7px;
	}
}

@media only screen and (max-width: $large-glass) {
	.notifications {
		margin-right: 15px;
	}
	.notification-count-container {
		top: -8px;
	}
}
</style>
